module.exports = __webpack_public_path__ + "static/img/cover.311c00d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/10/cover.jpg
// module id = z/C+
// module chunks = 27